import React from 'react'
import moment from 'moment';
import { Timer } from '../common/svg';
import { baseCss } from '../common/css';
import { tCommon, TRIP_CODE, DEPARTURE_TIME } from '../../../translations/Common';
import { t, TRIP_SHEET_STATUS, VEHICLE_NUMBER, CREW_CONTACT_NO, SERVICE_STATUS, BOARDING_POINT, BOARDING_TIME } from '../../../translations/pnrEnquiry/Trip/Trip';



const TripDetails = (props) => {
    const topDtls = props.topDtls && props.topDtls.length > 0 ? props.topDtls[0] : [];
    const pickdropDtls = props.pickdropDtls && props.pickdropDtls.length > 0 ? props.pickdropDtls.sort((a, b) => new Date(a.PickupTime) - new Date(b.PickupTime)) : [];

    const TripCards = (props) => {
        const { val } = props;
        return (
            <div className="trip-cards scroll">
                <div className="cardhead">
                    <div className="cardhead-left-content">{val.PickupName} </div>
                    <div className="cardhead-right-content">
                        <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Timer /></span>
                        <span>{moment(val.PickupTime).format('HH:mm ddd D MMM')}</span>
                    </div>
                </div>
                <div className="cardFooter">
                    {val.PickupAddress}
                </div>
            </div>
        )
    }

    function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    return (
        <div className='tripDetail-container'>
            <div className="tripDetail-header" style={{ backgroundColor: 'var(--ksrtcThColor1)' }}>
                {tCommon(TRIP_CODE)}: {topDtls && topDtls.TripCode} - {topDtls && capitalizeFirstLetter(topDtls.FromCity)}{" to "}{topDtls && capitalizeFirstLetter(topDtls.ToCity)} {" - "} {topDtls && topDtls.BusType} {" | "} {tCommon(DEPARTURE_TIME)} {":"} {topDtls && moment(topDtls.JourneyDate).format("DD MMM YY, HH:mm")}
            </div>
            <div className='bus-trip-detail'>
                <div className='left--part'>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '40%' }}>{t(TRIP_SHEET_STATUS)}</div>
                        <div>&nbsp;{":"}&nbsp;{topDtls.TripSheetStatus}</div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '40%' }}>{t(VEHICLE_NUMBER)}</div>
                        <div>&nbsp;{":"}&nbsp;{topDtls.VehicleNo ? topDtls.VehicleNo : '-'}</div>
                    </div>
                </div>
                <div className='right--part'>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '40%' }}>{t(CREW_CONTACT_NO)} </div>
                        <div>&nbsp;{":"}&nbsp;{topDtls.CrewName ? topDtls.CrewName : '-'}</div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '40%' }}>{t(SERVICE_STATUS)}</div>
                        <div>&nbsp;{":"}&nbsp;{topDtls.TripStatus ? topDtls.TripStatus : '-'}</div>
                    </div>
                </div>
            </div>
            <div className="tripDetails-content">
                {
                    topDtls.TripStatus === "Ended" ?
                        <div className="tripDetail-subHeading">
                            <div className="subhead-left-content">The trip is completed as the bus has reached it's destination.</div>
                            <div className="subhead-right-content-completed">COMPLETED</div>
                        </div>
                        : topDtls.TripStatus === "Cancelled" ?
                            <div className="tripDetail-subHeading">
                                <div className="subhead-left-content">This trip is cancelled by the bus operator.</div>
                                <div className="subhead-right-content-cancelled">CANCELLED</div>
                            </div>
                            :
                            <div className="tripDetail-subHeading">
                                <div className="subhead-left-content">{t(BOARDING_POINT)}</div>
                                <div className="subhead-right-content">{t(BOARDING_TIME)}</div>
                            </div>
                }
                {

                    <div className="tripCard">
                        {
                            pickdropDtls && pickdropDtls.length > 0 && pickdropDtls.map(((val, i) => <TripCards key={i} val={val} />))
                        }
                    </div>
                }

            </div>
        </div>
    )
}

export default TripDetails